import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "../supabaseClient";
import loginImage from "../assets/images/loginimage.png";
import strobeLogoMono from "../assets/images/strobelogo.svg";
import { Eye, EyeOff } from "lucide-react";
import PortalFeedback from "./PortalFeedback";

export default function UpdatePassword() {
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setError(null);
    const { error } = await supabase.auth.updateUser({ password: newPassword });
    if (error) {
      setError(error.message);
    } else {
      setSuccess(true);
      setTimeout(() => navigate("/login"), 2000);
    }
  };

  return (
    <div className="relative min-h-screen bg-black overflow-hidden">
      {/* Background Image */}
      <img
        src={loginImage}
        alt="Login Background"
        className="absolute inset-0 w-full h-full object-cover opacity-70"
      />

      {/* Centered Card */}
      <div className="relative z-10 flex items-center justify-center min-h-screen px-4">
        <div className="w-full max-w-lg bg-white/10 backdrop-blur-xl text-white rounded-xl shadow-2xl border border-white/20 p-10">
          <div className="flex flex-col items-center justify-center text-center mb-6">
            <Link to="/">
              <img src={strobeLogoMono} alt="Strobe Logo" className="w-36 mb-4 hover:opacity-90 transition" />
            </Link>
            <h2 className="text-3xl font-bold">Set a New Password</h2>
          </div>

          <form onSubmit={handleReset} className="space-y-4">
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="New password"
                className="w-full px-4 py-2 pr-10 bg-white/10 border border-white/30 text-white rounded-md placeholder-white/60 focus:outline-none"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-white/70 hover:text-white transition"
                tabIndex={-1}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            {error && <PortalFeedback type="error" variant="dark">{error}</PortalFeedback>}
            {success && <PortalFeedback type="success" variant="dark">Password updated! Redirecting…</PortalFeedback>}

            <button
              type="submit"
              className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-2 rounded-md transition"
            >
              Update Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
